<template><BusinessPage module-key="notices" /></template>
<script>import BusinessPage from '../common/BusinessPage.vue'; export default { name: 'NoticesPage', components: { BusinessPage } }</script>
